import CanvasJSReact from './canvasjs.react';

const { CanvasJS } = CanvasJSReact;
const { CanvasJSChart } = CanvasJSReact;

// readme: https://canvasjs.com/docs/charts/chart-options/culture/
CanvasJS.addCultureInfo('pt-br', {
  decimalSeparator: ',',
  digitGroupSeparator: '.',
  zoomText: 'Zoom',
  panText: 'Arrastar',
  resetText: 'Redefinir',
  savePNGText: 'Salvar como PNG',
  saveJPGText: 'Salvar como JPG',
  menuText: 'Mais opções',
  days: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'],
  shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
});
CanvasJS.addCultureInfo('es', {
  decimalSeparator: '.',
  digitGroupSeparator: ',',
  zoomText: 'Zoom',
  panText: 'Arrastar',
  resetText: 'Redefinir',
  savePNGText: 'Salvar como PNG',
  saveJPGText: 'Salvar como JPG',
  menuText: 'Mais opções',
  days: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'],
  shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
});

export { CanvasJS, CanvasJSChart };
export default CanvasJSReact;
